'use client';

export function CheckboxInput({
  name,
  label,
  checked,
  onChange,
  disabled = false,
}) {
  return (
    <label className="flex items-center gap-2 text-xs text-gray-700 select-none">
      <input
        type="checkbox"
        name={name}
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked, e)}
        className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
      />
      <span>{label}</span>
    </label>
  );
}